/**
 * TUVI - Reintentos automáticos globales para fetch
 *
 * Intercepta TODOS los fetch del sistema y, si el servidor responde
 * con un error temporal (5xx) o falla la red, reintenta automáticamente
 * con espera exponencial: 1s → 2s → 4s
 *
 * El usuario verá la pantalla "cargando" por unos segundos en lugar
 * de recibir un error, y cuando el servidor libere carga la petición
 * se completará sola.
 *
 * No requiere cambios en ningún componente — se aplica globalmente
 * al importarse en index.js antes que cualquier otro módulo.
 */

const _fetchOriginal = window.fetch.bind(window);

const MAX_REINTENTOS = 3;         // 3 reintentos máx después del intento inicial
const DELAY_BASE_MS  = 1000;      // 1s → 2s → 4s (backoff exponencial)

// Códigos de respuesta que indican sobrecarga / error temporal del servidor
const REINTENTAR_EN_STATUS = new Set([500, 502, 503, 504]);

const esperar = (ms) => new Promise((r) => setTimeout(r, ms));

async function fetchConReintentos(input, init, intento = 0) {
  try {
    const resp = await _fetchOriginal(input, init);

    // Errores de servidor temporales → reintentar
    if (REINTENTAR_EN_STATUS.has(resp.status) && intento < MAX_REINTENTOS) {
      const demora = DELAY_BASE_MS * Math.pow(2, intento); // 1s, 2s, 4s
      await esperar(demora);
      return fetchConReintentos(input, init, intento + 1);
    }

    return resp;

  } catch (err) {
    // Error de red (sin conexión, timeout TCP, servidor no responde)
    if (intento < MAX_REINTENTOS) {
      const demora = DELAY_BASE_MS * Math.pow(2, intento);
      await esperar(demora);
      return fetchConReintentos(input, init, intento + 1);
    }
    // Agotados los reintentos → propagar el error al componente
    throw err;
  }
}

// Reemplaza fetch global — afecta automáticamente a todos los componentes
window.fetch = fetchConReintentos;
